import { Injectable } from "@angular/core";
import { WebApiService } from "../../_libs/web-api";
import { EnvConfigProvider } from "../_core/services/env-config.provider";
import { Auth0User } from "app/_core/services/models/auth0-user.model";
import { LocalStorageService } from "../../@dodo/local-storage/trycatch-local-storage.service";
import { LocalStorageKeys } from "../_core/services/local-storage-state-restor.service";
import { Router } from "@angular/router";
import { BaseWebApiService } from "../_core/services/-base-webapi.service";
import { DodoService } from "app/_core/services/models/dodo-service.model";

@Injectable({
	providedIn: "root"
})
export class DealerService extends BaseWebApiService {
	private targetPathMap = {
		internet: "internet",
		mobile: "mobile/plans",
		energy: "energy"
	};

	constructor(
		private __router: Router,
		private __localStore: LocalStorageService
	) {
		super();
	}

	targetPath(target: string): string {
		return this.targetPathMap[target];
	}

	storeDealer(dealer: Auth0User) {
		this.__localStore.setInLocalStorage(LocalStorageKeys.dealer, dealer);
	}

	storeDealerSelectedService(service: DodoService) {
		const dealer = this.getDealer();
		dealer.service = service;
		this.storeDealer(dealer);
	}

	getDealer(): Auth0User {
		return <Auth0User>(
			this.__localStore.getFromLocalStorage(LocalStorageKeys.dealer)
		);
	}

	deleteDealer() {
		this.__localStore.deleteFromLocalStorage(LocalStorageKeys.dealer);
	}

	navigateUserToTarget(target: string) {
		this.__router.navigate([this.targetPath(target)]);
	}

}
